var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1JfhlADOgXL50c{background-image:url(" + escape(require("app/src/components/AtlassianAccountOnboardingBanner/images/locks.png")) + ");background-position-x:left;background-position-y:top;background-attachment:scroll;background-repeat:no-repeat;background-size:contain;padding-left:320px;min-height:124px}@media only screen and (max-width:1440px){._1JfhlADOgXL50c{background-position-x:-128px;padding-left:192px}}@media only screen and (max-width:1312px){._1JfhlADOgXL50c{padding-left:26px;background-image:none}}._2jgKl8Z89cjnoH{display:flex;justify-content:left;align-items:center;margin:22px 0;padding-left:24px}._1a_oxSYebDgbzP{display:flex;flex:1.3}._1GLPDU72jX7GLR{color:#172b4d;font-size:14px;font-weight:400;line-height:20px;max-width:90ch;margin:0}._3LZqaiqffa7WWJ{flex:1}._3LZqaiqffa7WWJ button{margin:0 0 0 24px}._3avckVxrAGa5Eq{position:absolute;top:0;right:0;height:100%}", ""]);

// exports
exports.locals = {
	"banner": "_1JfhlADOgXL50c",
	"container": "_2jgKl8Z89cjnoH",
	"body": "_1a_oxSYebDgbzP",
	"text": "_1GLPDU72jX7GLR",
	"controls": "_3LZqaiqffa7WWJ",
	"onboardingImage": "_3avckVxrAGa5Eq"
};